module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plates",
    attrs: {
      "id": "plates21"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "plate21",
      "src": "images/plate21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pilots of 54 Squadron at Richmond, November 1942. Front (left to right): PO G Wall, PO A McIntyre, FO R Beaton (EO), FL E Weatherhead (Adj), RFW, SL E M Gibbs, FL R Norwood, FL D G Jarman (MO), PO J Councer (IO), PO A K Brook, PO G C F Farries. Rear: Sgt Studley, Sgt W Eldred, FS B Mahoney, FS Miller, FS F L Varney(†), FS J C Wellsman(†), Sgt D Monger, Sgt G Horkin, Sgt P F McCarthy (†). († - killed with the Wing)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c27af47e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_TallyHo_plates21.vue
// module id = 126
// module chunks = 0